import { HYDRA_SCAN_START, hydraScanEndAction } from 'actions/app-actions';
import { mergeMap, timeout, catchError, mapTo } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { ofType, combineEpics } from 'redux-observable';
import {
  getHydraScanFunc,
  hydraScanFromResponse,
} from 'applications/hydra/hydra-utils';

const hydraScanStartEpic = action$ =>
  action$.pipe(
    ofType(HYDRA_SCAN_START),
    mergeMap(({ sourceType, data }) =>
      from(
        // We do not know if the hydra function may change behaviour to non Promise in the future, hence we add a Promise wrapper
        new Promise(resolve => {
          resolve(hydraScanFromResponse(getHydraScanFunc(), data));
        }),
      ).pipe(
        // Do not wait the hydra scan response for too long
        timeout(800),
        mapTo(hydraScanEndAction(sourceType)),
        catchError(err =>
          // Do not let hydra errors affect application behaviour (but we still want to know the error in the action)
          of(hydraScanEndAction(sourceType, err)),
        ),
      ),
    ),
  );

export default combineEpics(hydraScanStartEpic);
